import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ShimmerTable, ShimmerTitle, ShimmerCircularImage } from "react-shimmer-effects";

import CloudAccountScoreAssessmentData from '../../../data/ops-view/SecurityStackCloudSecurity/CloudAccountScoreAssessment.json';
import { MdAccountBox } from "react-icons/md";


const CloudAccountScoreAssessment = (props) => {

  const [onLoading, setOnLoading] = useState(false)

  const data = props.data.charts;

  const [parentWidth, setParentWidth] = useState(0);  

  const theContainer = {
    backgroundColor: '#ccc',
    height: '10px',
    borderRadius: '0px',
    position: 'relative',
    width: '50%',
    marginTop: 10,
    marginBottom: 10
  };

  const riskProgressStyle1 = {
    backgroundColor: '#21cf49',
    height: '100%',
    borderRadius: '0px',
    width: `${data.cloudAcccountScoreAssessment.aPercent}%`,
  };

  const riskProgressStyle2 = {
    backgroundColor: '#ffbc55',
    height: '100%',
    borderRadius: '0px',
    width: `${data.cloudAcccountScoreAssessment.bPercent}%`,
  };

  const riskProgressStyle3 = {
    backgroundColor: '#db483c',
    height: '100%',
    borderRadius: '0px',
    width: `${data.cloudAcccountScoreAssessment.cPercent}%`,
  };

  const riskProgressStyle4 = {
    backgroundColor: '#00a3ae',
    height: '100%',
    borderRadius: '0px',
    width: `${data.cloudAcccountScoreAssessment.dPercent}%`,
  };

  const riskProgressStyle5 = {
    backgroundColor: '#b60608',
    height: '100%',
    borderRadius: '0px',
    width: `${data.cloudAcccountScoreAssessment.ePercent}%`,
  };





  useEffect(() => {
    const updateParentWidth = () => {
      const parentDiv = document.getElementById('parentDiv');
      if (parentDiv) {
        const width = parentDiv.offsetWidth;
        setParentWidth(width * 0.95); // Assigning 90% width
      }
    };

    updateParentWidth();

    window.addEventListener('resize', updateParentWidth);

    return () => {
      window.removeEventListener('resize', updateParentWidth);
    };
  }, []);


  return (
    <div style={{
      width: '49%', marginLeft: 0, display: 'flex', flexDirection: 'column', height: 350,
      marginTop: '2%', background: 'linear-gradient(135deg, #161c2a, #1a2130)', padding: 20, borderRadius: 15
    }}>


     


      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', marginTop: 10 }}>


      <div style={{ height: 60, }}>
          <h6 style={{ color: '#fff', textAlign: 'left' }}>Cloud Account Score Assessment</h6>
          <hr />
</div>

          <div style={{
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
            alignItems: 'center', height: 250
          }}>


            <div style={{ display: 'flex', flexDirection: 'column', borderRadius: 5, border: '1px solid white', padding: 10,
          backgroundColor:'#fff', alignItems:'center', justifyContent:'space-between', width:150, height:150  }}>

            <MdAccountBox size={40} style={{color:'#009688'}}/>

              <span style={{ fontSize: 25, textAlign: 'center', color:'#000' }}>{data.cloudAcccountScoreAssessment.accounts}</span>
              <span style={{ fontSize: 18, textAlign: 'center', color:'#000' }}>Accounts</span>

            </div>


            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width:'60%' }}>

              <div style={{ width: '100%', display:'flex', flexDirection:'row',justifyContent: 'space-between', }}>
                <span style={{ fontWeight: 'bold', width:'20%',color:'#fff' }}>A</span>
                <div style={theContainer}>
                  <div style={riskProgressStyle1}></div>
                </div>
                <span style={{ fontWeight: 'bold', width:'20%',color:'#fff'  }}>{data.cloudAcccountScoreAssessment.aPercent}</span>
              </div>

              <div style={{ width: '100%', display:'flex', flexDirection:'row',justifyContent: 'space-between', }}>
                <span style={{ fontWeight: 'bold',width:'20%',color:'#fff'  }}>B</span>
                <div style={theContainer}>
                  <div style={riskProgressStyle2}></div>
                </div>
                <span style={{ fontWeight: 'bold', width:'20%',color:'#fff'  }}>{data.cloudAcccountScoreAssessment.bPercent}</span>
              </div>

              <div style={{ width: '100%', display:'flex', flexDirection:'row',justifyContent: 'space-between',}}>
                <span style={{ fontWeight: 'bold', width:'20%',color:'#fff'  }}>C</span>
                <div style={theContainer}>
                  <div style={riskProgressStyle3}></div>
                </div>
                <span style={{ fontWeight: 'bold', width:'20%',color:'#fff'  }}>{data.cloudAcccountScoreAssessment.cPercent}</span>
              </div>

              <div style={{ width: '100%', display:'flex', flexDirection:'row',justifyContent: 'space-between',}}>
                <span style={{ fontWeight: 'bold', width:'20%' ,color:'#fff' }}>D</span>
                <div style={theContainer}>
                  <div style={riskProgressStyle4}></div>
                </div>
                <span style={{ fontWeight: 'bold', width:'20%' ,color:'#fff' }}>{data.cloudAcccountScoreAssessment.dPercent}</span>
              </div>


              <div style={{ width: '100%', display:'flex', flexDirection:'row',justifyContent: 'space-between',}}>
                <span style={{ fontWeight: 'bold', width:'20%',color:'#fff'  }}>E</span>
                <div style={theContainer}>
                  <div style={riskProgressStyle5}></div>
                </div>
                <span style={{ fontWeight: 'bold', width:'20%',color:'#fff'  }}>{data.cloudAcccountScoreAssessment.ePercent}</span>
              </div>

            </div>



          </div>
        </div>
      </div>


  );
};

export default CloudAccountScoreAssessment;